import { useSelector } from "react-redux";
import { getConfigurationTheme, getCustomFormHelpText, getFormHelpTextType, getHeadErrorMessage, getHeadErrorToFooter, getIsPolicyDecisionRetry } from "../../../redux/selectors/verification-configuration-selectors";
import { getAssertionErrorMessages, getShouldRetryVerification } from "../../../redux/selectors/verification-form-selectors";
import { getSubmissionComplete } from "../../../redux/selectors/submission-selectors";
import { CustomHtmlContainer } from "@iddataweb/idw-common-ui/containers";
import { PreFormHelpTextContainer } from "../pre-form-help-text/pre-form-help-text-container";
import { ErrorMessagesContainer } from "../error-messages-container/error-messages-container";
import { getLanguageContent } from "../../../redux/selectors/language-selectors";

type PreAttributeListContainerProps = {
    useThemedUI: boolean;
    canShowPolicyDecisionRetryMessage: boolean;
};

export const PreAttributeListContainer = (props: PreAttributeListContainerProps) => {
    const {
        useThemedUI,
        canShowPolicyDecisionRetryMessage
    } = props;

    const theme = useSelector(getConfigurationTheme)
    const content = useSelector(getLanguageContent);
    const isPolicyDecisionRetry = useSelector(getIsPolicyDecisionRetry);
    const customFormHelpText = useSelector(getCustomFormHelpText);
    const formHelpTextType = useSelector(getFormHelpTextType);
    const showErrorsInFooter = useSelector(getHeadErrorToFooter);
    const headErrorMessage = useSelector(getHeadErrorMessage);
    const shouldRetryVerification = useSelector(getShouldRetryVerification);
    const assertionErrorMessages = useSelector(getAssertionErrorMessages);
    const submissionComplete = useSelector(getSubmissionComplete);

    const showHeaderPolicyDecisionRetryError = !submissionComplete && !showErrorsInFooter && isPolicyDecisionRetry && canShowPolicyDecisionRetryMessage;
    const showHeaderInlineRetryError = shouldRetryVerification && submissionComplete && !showErrorsInFooter && assertionErrorMessages.length === 0;
    const showHeaderAssertionErrors = shouldRetryVerification && submissionComplete && !showErrorsInFooter && assertionErrorMessages.length > 0;

    return (
        <>
            {!useThemedUI && formHelpTextType && !customFormHelpText && (
                <CustomHtmlContainer
                    id="form-help-text"
                    className={"form-help-text"}
                    //@ts-ignore
                    htmlContent={content.formHelpTextType[formHelpTextType]}
                />
            )}
            {!useThemedUI && customFormHelpText && (
                <CustomHtmlContainer id={"custom-form-help-text"} htmlContent={customFormHelpText} />
            )}
            {useThemedUI && (<PreFormHelpTextContainer />)}
            {!showErrorsInFooter && (
                <ErrorMessagesContainer
                    showPolicyDecisionRetryError={showHeaderPolicyDecisionRetryError}
                    showInlineRetryError={showHeaderInlineRetryError}
                    content={content}
                    theme={theme}
                    useThemedUI={useThemedUI}
                    inlineErrorMessage={headErrorMessage}
                    showAssertionErrors={showHeaderAssertionErrors}
                    assertionErrorMessages={assertionErrorMessages}
                />
            )}
        </>
    );
};